import AttendanceService from '../services/AttendanceService';
import router from '../router';
import uuidv4 from '../router';

const getDefaultState = () => ({
  attendance: {
    id: null,
    student_id: '',
    student_uuid: '',
    month: '',
    year: '',
    present: 0,
    total_days: 0,
  },
  studentAttendance: [],
  manyAttendanceRecords: [],
  oneMonthAttendance: [],
  attendanceSummaryTable: [],
});

const attendance = {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    id(state, val) {
      state.attendance.id = val;
    },
    month(state, val) {
      state.attendance.month = val;
    },
    year(state, val) {
      state.attendance.year = val;
    },
    present(state, val) {
      state.attendance.present = val;
    },
    total_days(state, val) {
      state.attendance.total_days = val;
    },
    oneMonthAttendance(state, val) {
      state.oneMonthAttendance = val;
    },
    bulkAddMonth(state, val) {
      state.oneMonthAttendance.map(item => (item.month = val));
    },
    bulkAddYear(state, val) {
      state.oneMonthAttendance.map(item => (item.year = val));
    },
    bulkAddTotalDays(state, val) {
      state.oneMonthAttendance.map(item => (item.total_days = val));
    },
    attendanceSummaryTable(state, val) {
      state.attendanceSummaryTable = val;
    },
    resetAttendance(state) {
      Object.assign(state, getDefaultState());
    },
  },
  actions: {
    async POST_ATTENDANCE_RECORD({ state }) {
      await AttendanceService.addAttendanceRecord(state.attendance);
    },
    async ADD_BULK_ATTENDANCE({ state }) {
      await AttendanceService.addBulkAttendanceRecords(
        state.oneMonthAttendance
      );
    },
    async UPDATE_ATTENDANCE_RECORD({ state }) {
      await AttendanceService.updateAttendanceRecord(state.attendance);
    },
    async GET_ATTENDANCE_RECORDS(context) {
      context.rootState.attendance.studentAttendance = [];
      const studentRecords = await AttendanceService.fetchAttendanceByStudent({
        student_id: router.currentRoute.params.id,
      });
      context.rootState.attendance.studentAttendance =
        studentRecords.data.attendances;
    },
    async GET_ONE_MONTH_ATTENDANCE(context, teacherId, month, year) {
      const payload = await AttendanceService.fetchOneMonthAttendanceByTeacher(
        teacherId,
        month,
        year
      );
      const data = payload.data.results;
      context.commit('oneMonthAttendance', data);
    },
    async ADD_ONE_MONTH_ATTENDANCE({ state }) {
      await AttendanceService.addOneMonthAttendanceByTeacher(
        {
          teacher_id: router.currentRoute.params.id,
        },
        state.oneMonthAttendance
      );
    },
    async UPDATE_ONE_MONTH_ATTENDANCE({ state }, context) {
      const payload = await AttendanceService.fetchOneMonthAttendanceByTeacher({
        teacher_id: router.currentRoute.params.id,
        month: state.month,
        year: state.year,
      });
      const data = payload.data.results;
      context.commit('oneMonthAttendance', data);
    },
    async GET_ATTENDANCE_SUMMARY_TABLE(context) {
      const payload = await AttendanceService.fetchAttendanceSummaryTable({
        teacher_id: router.currentRoute.params.id,
      });
      const data = payload.data.results;
      context.commit('attendanceSummaryTable', data);
    },
    async BULK_UPDATE_ALL({ state }) {
      await AttendanceService.bulkUpdateOneMonthAttendanceByTeacher(
        state.oneMonthAttendance
      );
    },
    async RESET_ATTENDANCE_STATE(context) {
      await context.commit('resetAttendance');
    },
  },
  getters: {
    getStudentAttendance: state =>
      state.studentAttendance.map(a => ({
        month: a.month,
        year: a.year,
        month_year: `${a.month}, ${a.year}`,
        present: a.present,
        absent: a.total_days - a.present,
        total_days: a.total_days,
        edit: 'Edit',
        id: a.id,
      })),
    getTeacherAttendanceSummary: state => {
      const data = state.teacherStudentsAttendance;
      return data;
    },
  },
};

export default attendance;
